export var SECTION_ATTR="data-section-id";
//# sourceMappingURL=constants.js.map